import axios from "axios";
import { encryptStorage } from "../../../../constants/EncryptStorage";
import getUrl from "../../../../constants/urlConst";


export function ApiAirline() {
  const userToken = encryptStorage.getItem("token");

  const authAxios = axios.create({
    baseURL: getUrl(),
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });

  return {
    addAirline: async (model) => {
      try {
        const response = await authAxios.post(getUrl() + "airline/add", model);
        return response.data;
      } catch (error) {
        console.error("Error adding airline:", error);
        throw error;
      }
    },

    getAirline: async () => {
      try {
        const response = await authAxios.get(getUrl() + "airline/list");
        return response.data;
      } catch (error) {
        console.error("Error fetching airlines:", error);
        throw error;
      }
    },
    
    getAirlineById: async (id) => {
      try {
        const response = await authAxios.get(getUrl() + `airline/${id}`);
        return response.data;
      } catch (error) {
        console.error("Error fetching luggages:", error);
        throw error;
      }
    },

    getAirlineOptions: async () => {
      try {
        const response = await authAxios.get(getUrl() + "airlineOptions");
        return response.data;
      } catch (error) {
        console.error("Error fetching airline options:", error);
        throw error;
      }
    },

    updateAirline: async (model) => {
      try {
        const response = await authAxios.post(getUrl() + "airline/update", model);
        return response.data;
      } catch (error) {
        console.error("Error updating airline:", error);
        throw error;
      }
    },

     deleteAirline: async (airlineId) => {
      try {
        const response = await authAxios.delete(getUrl() + `airline/${airlineId}`);
        return response.data;
      } catch (error) {
        console.error("Error deleting airline:", error);
        throw error;
      }
    },

  };
}
